export function toAttachmentId(chatMessageId: string, attachmentIndex: number) {
  return `${chatMessageId}-${attachmentIndex}`;
}
